import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { FormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { PaymentDetails } from "../../shared/models/paymentdetails";
import { ExpiryDateFormatterPipe } from "../expiry-date-formatter.pipe";
import {
  AuthRequestModel,
  AuthResponseModel,
  CardDetails,
  PaymentRequestModel,
  ResponseModel,
} from "./card-processing-model";
import * as util from "../card.util";
import { PaymentService } from "../../shared/services/payment.service";
import { FinalTxnStatus } from "../../shared/models/transaction.status";
import { ActivatedRoute, Router } from "@angular/router";
import { ResponseCodes } from "../../shared/models/bankPaymentRes";
import { urlShortener } from "src/app/core/constants/constants";
import {
  CheckoutSettings,
  WhiteLabelInfo,
  ConfirmAccountTransfer,
} from "src/app/core/models/model";
import { takeUntil, switchMap, tap } from "rxjs/operators";
import { Subject, timer } from "rxjs";
import { ToastrService } from "ngx-toastr";
import posthog from "posthog-js";
import { StorageService } from "src/app/core/helpers/storage-Service";

@Component({
  selector: "app-card-data-capture",
  templateUrl: "./card-data-capture.component.html",
  styleUrls: ["./card-data-capture.component.css"],
  standalone: false,
})
export class CardDataCaptureComponent implements OnInit, OnDestroy {
  @ViewChild("viewContainer", { read: ViewContainerRef, static: true })
  vc: ViewContainerRef;
  @ViewChild("cardView", { read: TemplateRef, static: true })
  cardView: TemplateRef<any>;
  @ViewChild("tokenView", { read: TemplateRef, static: true })
  tokenView: TemplateRef<any>;
  @ViewChild("loadingView", { read: TemplateRef, static: true })
  loadingView: TemplateRef<any>;

  @ViewChild("errorView", { read: TemplateRef, static: true })
  errorView: TemplateRef<any>;

  @ViewChild("visaView", { read: TemplateRef, static: true })
  visaView: TemplateRef<any>;

  @ViewChild("challengeView", { read: TemplateRef, static: true })
  challengeView: TemplateRef<any>;

  @Input() paymentDetails: PaymentDetails;
  @Input() whiteLabelInfo: WhiteLabelInfo;

  paymentRequest = new PaymentRequestModel();
  authRequest = new AuthRequestModel();

  cardForm: UntypedFormGroup;
  activePage: TemplateRef<any>;

  transactionResponse: ResponseModel;
  finalTxnStatus = new FinalTxnStatus();

  paymentRef: string;
  errorResponse: string;

  otpError: string;
  visaResponse: any;

  subHeader: string;
  showModal: boolean;

  @Output() isMakingPayment = new EventEmitter();
  destroy$ = new Subject<void>();

  header: string = "";
  checkoutSettings: CheckoutSettings;

  @ViewChild("challengeContainer", { static: false })
  challengeContainerRef!: ElementRef<HTMLDivElement>;

  lastChargeResponse: any | null = null;
  cyberResponse: any;
  private challengeAuthorizeFired = false;
  constructor(
    private expdate: ExpiryDateFormatterPipe,
    private txnserv: PaymentService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // set the embedded view to be injected in to the viewcontainer
  setView(page: string, message?: string) {
    this.vc.clear();
    switch (page) {
      case "card":
        this.vc.createEmbeddedView(this.cardView);
        break;
      case "token":
        this.vc.createEmbeddedView(this.tokenView);
        break;
      case "visa":
        this.vc.createEmbeddedView(this.visaView);
        break;
      case "challenge":
        this.vc.createEmbeddedView(this.challengeView);
        break;
      case "error":
        this.vc.createEmbeddedView(this.errorView);
        this.errorResponse = message;
        break;
      default:
    }
  }

  setTxnStatusMessage(status) {
    this.finalTxnStatus.amount = this.paymentDetails.amount;
    // this.finalTxnStatus.callbackUrl = this.paymentDetails.callbackURL;
    this.finalTxnStatus.currency = this.paymentDetails.currency;
    this.finalTxnStatus.status = status == "00" ? "success" : "failed";

    if (this.paymentDetails.callbackURL) {
      this.finalTxnStatus.callbackUrl = this.paymentDetails.callbackURL;
    }

    this.finalTxnStatus.callbackUrl = urlShortener(
      this.finalTxnStatus.callbackUrl,
    );

    this.finalTxnStatus.redirectUrl = this.paymentDetails.redirectUrl;

    if (status === ResponseCodes.success) {
      this.redirectPage();
    }
  }

  private redirectPage() {
    this.router.navigateByUrl(
      `/status/${btoa(JSON.stringify(this.finalTxnStatus))}`,
    );
  }

  ngOnInit() {
    this.checkoutSettings =
      this.storageService.getPaymentInfo() as CheckoutSettings;
    this.setView("card");

    this.route.params.subscribe((res) => (this.paymentRef = res.payRef));
  }

  setActivePage(pageName) {
    document.getElementById("loaderMan").style.display = "none";
    document.getElementById("noCardOption").style.display = "none";
    document.getElementById("main").style.display = "block";
    let pages = document.querySelectorAll(".form-page");
    for (let i = 0; i < pages.length; i++) {
      let page = pages[i];
      page.classList.remove("show");
    }

    let activePage = document.querySelector(".form-page." + pageName);
    activePage.classList.add("show");
  }

  //update the payment request with the emitted value and the payment details
  private setPaymentRequestValue(carddetails: CardDetails) {
    this.paymentRequest.cardDetails = carddetails;
    this.paymentRequest.cardDetails.expiryDate = carddetails.expiryDate.replace(
      /\\|\//g,
      "",
    );

    this.paymentRequest.amount = this.paymentDetails.amount;
    this.paymentRequest.customerId = this.paymentDetails["metadata"].email
      ? this.paymentDetails["metadata"].email
      : this.paymentDetails["userId"];
    this.paymentRequest.reference = this.paymentDetails.referenceId;
    this.paymentRequest.currency = this.paymentDetails.currency;
  }

  // set Authorization Request
  private setAuthorizationReq(otp) {
    this.authRequest.cardDetails = this.paymentRequest.cardDetails;
    this.authRequest.paymentId = this.transactionResponse.paymentId;
    this.authRequest.otp = otp;
  }

  // Non-sensitive props shared by all card analytics events.
  // NOTE: never include PAN / CVV / PIN / OTP here.
  private cardEventProps() {
    return {
      clientId: this.paymentDetails?.clientId,
      amount: this.paymentDetails?.amount,
      currency: this.paymentDetails?.currency,
      reference: this.paymentDetails?.referenceId,
    };
  }

  //Make payment request
  async processTransaction(cardInput) {
    this.setPaymentRequestValue(cardInput);

    this.isMakingPayment.emit("card");

    this.paymentRequest.reference = this.paymentDetails.referenceId;
    this.paymentRequest.cardDetails.pan =
      this.paymentRequest.cardDetails.pan.replace(/\s/g, "");

    posthog.capture("card_payment_initiated", this.cardEventProps());

    let encrypted = await util.encryptData(this.paymentRequest);

    // this.setView("loading");

    if (this.checkoutSettings.internationalPaymentEnabled) {
      return this.txnserv.initiateCard(encrypted).subscribe(async (res) => {
        try {
          const decryptedResponse = await util.decryptData(
            res.encryptedResponse,
          );

          const decryptedRes =
            typeof decryptedResponse === "string"
              ? JSON.parse(decryptedResponse)
              : decryptedResponse;

          this.cyberResponse = decryptedRes;

          if (decryptedRes.responseCode === "02") {
            await this.runDeviceDataCollection(
              decryptedRes.deviceDataCollectionUrl,
              decryptedRes.accessToken,
              decryptedRes.referenceId,
            ).then((res) => {
              this.txnserv.processCard(encrypted).subscribe(async (res) => {
                let decryptedRes = await util.decryptData(
                  res.encryptedResponse,
                );

                this.transactionResponse = JSON.parse(decryptedRes);

                if (
                  this.transactionResponse.responseCode ===
                  ResponseCodes.success
                ) {
                  posthog.capture("card_payment_successful", {
                    ...this.cardEventProps(),
                    responseCode: this.transactionResponse.responseCode,
                  });
                  this.setTxnStatusMessage(
                    this.transactionResponse.responseCode,
                  );
                } else if (
                  this.transactionResponse.responseCode ===
                  ResponseCodes.tokenResponse
                ) {
                  posthog.capture("otp_challenge_shown", this.cardEventProps());
                  this.setView("token");
                } else if (
                  this.transactionResponse.responseCode ===
                  ResponseCodes.visaResponse
                ) {
                  this.setView("challenge");
                  this.cdr.detectChanges();
                  // this.visaResponse = this.transactionResponse;

                  posthog.capture(
                    "threeds_challenge_shown",
                    this.cardEventProps(),
                  );
                  this.showChallengeFrame(
                    this.transactionResponse.acsUrl,
                    this.transactionResponse.jwt,
                  );
                } else if (
                  this.transactionResponse.responseCode === ResponseCodes.error
                ) {
                  this.header = "Transaction Failed";
                  this.showModal = true;

                  this.errorResponse =
                    this.transactionResponse.responseDescription;
                  this.subHeader = this.errorResponse;

                  posthog.capture("card_payment_failed", {
                    ...this.cardEventProps(),
                    responseCode: this.transactionResponse.responseCode,
                    reason: this.transactionResponse.responseDescription,
                  });
                } else {
                  this.header = "Transaction Failed";
                  this.showModal = true;
                  this.subHeader = this.transactionResponse.responseDescription;

                  posthog.capture("card_payment_failed", {
                    ...this.cardEventProps(),
                    responseCode: this.transactionResponse.responseCode,
                    reason: this.transactionResponse.responseDescription,
                  });
                }
              });
            });

            // Continue with your next step here
          }
        } catch (error) {}
      });
    } else {
      this.txnserv.processCard(encrypted).subscribe(
        async (res) => {
          let decryptedRes = await util.decryptData(res.encryptedResponse);

          this.transactionResponse = JSON.parse(decryptedRes);

          if (this.transactionResponse.responseCode === ResponseCodes.success) {
            posthog.capture("card_payment_successful", {
              ...this.cardEventProps(),
              responseCode: this.transactionResponse.responseCode,
            });
            this.setTxnStatusMessage(this.transactionResponse.responseCode);
          } else if (
            this.transactionResponse.responseCode ===
            ResponseCodes.tokenResponse
          ) {
            posthog.capture("otp_challenge_shown", this.cardEventProps());
            this.setView("token");
          } else if (
            this.transactionResponse.responseCode === ResponseCodes.visaResponse
          ) {
            this.visaResponse = this.transactionResponse;

            posthog.capture("threeds_challenge_shown", this.cardEventProps());
            this.setView("visa");
          } else if (
            this.transactionResponse.responseCode === ResponseCodes.error
          ) {
            // this.setView("error");
            this.header = "Transaction Failed";
            this.showModal = true;

            this.errorResponse = this.transactionResponse.responseDescription;
            this.subHeader = this.errorResponse;

            posthog.capture("card_payment_failed", {
              ...this.cardEventProps(),
              responseCode: this.transactionResponse.responseCode,
              reason: this.transactionResponse.responseDescription,
            });
          } else {
            this.setView("error");
            this.header = "Transaction Failed";
            this.showModal = true;
            this.subHeader = this.transactionResponse.responseDescription;

            posthog.capture("card_payment_failed", {
              ...this.cardEventProps(),
              responseCode: this.transactionResponse.responseCode,
              reason: this.transactionResponse.responseDescription,
            });
          }
        },
        (err) => {
          const responseMessage = err?.error?.responseMessage;
          const SUS_ERROR_MSG =
            "Transaction declined, please contact support or try again";
          if (responseMessage === SUS_ERROR_MSG) {
            this.toastr.error(responseMessage);
          }

          posthog.capture("card_payment_error", {
            ...this.cardEventProps(),
            responseCode: err?.error?.responseCode,
            reason: responseMessage,
          });

          this.showModal = true;
          if (err.error.responseCode === ResponseCodes.error) {
            this.subHeader = "Transaction failed";
          }

          if (err.error.responseCode === "010") {
            this.subHeader = "Transaction failed";
          }
        },
      );
    }
  }

  //Authorize payment -- token validation
  //send otp autorizations
  async authorizeCardTxn(data: { otp: string }) {
    // this.setView("loading");
    // if (data.otp.length !== 6) {
    //   this.showModal = true;
    //   return (this.subHeader = "Incomplete OTP value");
    // }
    this.setAuthorizationReq(data.otp);

    posthog.capture("otp_submitted", this.cardEventProps());

    let otpVa = await util.encryptData(this.authRequest);

    this.txnserv.authorizeCard(otpVa).subscribe(
      async (res) => {
        let decryptedRes = await util.decryptData(res.encryptedResponse);
        const response = JSON.parse(decryptedRes);

        if (response.responseCode === ResponseCodes.success) {
          posthog.capture("otp_validation_successful", {
            ...this.cardEventProps(),
            responseCode: response.responseCode,
          });
          this.setTxnStatusMessage(response.responseCode);
        } else {
          const response = JSON.parse(decryptedRes);
          // this.setTxnStatusMessage(response.responseCode);
          // this.otpError = response.responseDescription;
          this.subHeader = response.responseDescription;
          this.showModal = true;

          posthog.capture("otp_validation_failed", {
            ...this.cardEventProps(),
            responseCode: response.responseCode,
            reason: response.responseDescription,
          });
        }
      },
      (err) => {},
    );
  }

  // resend otp

  async resendOtp() {
    posthog.capture("otp_resend_clicked", this.cardEventProps());

    let req = { ...this.paymentRequest };
    const reqToEncrypt = {
      reference: req.reference,
      amount: req.amount,
      customerId: req.customerId,
      cardDetails: req.cardDetails,
    };

    let otpVa = await util.encryptData(reqToEncrypt);
    this.txnserv
      .resendOtp(otpVa)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (res) => {
          let decryptedRes = await util.decryptData(res.encryptedResponse);
          const response = JSON.parse(decryptedRes);
          if (response.responseCode === ResponseCodes.tokenResponse) {
            this.subHeader = response.responseDescription;
            this.showModal = true;
          }
        },
        error: (err) => {},
      });
  }

  close() {
    this.showModal = false;
  }

  private runDeviceDataCollection(
    deviceDataCollectionUrl: string,
    accessToken: string,
    referenceId: string,
  ): Promise<void> {
    return new Promise((resolve) => {
      let done = false;

      const statusEl = document.getElementById("deviceCollectionStatus");

      if (statusEl) {
        statusEl.textContent = `Device data collection in progress (referenceId: ${referenceId})...`;
      }

      const finish = (msg: string) => {
        if (done) return;

        done = true;

        window.removeEventListener("message", onMessage);

        if (statusEl) {
          statusEl.textContent = msg;
        }

        resolve();
      };

      /**
       * Listen for profile.completed from Cardinal Commerce
       */
      const onMessage = (event: MessageEvent) => {
        // Make sure this is coming from Cardinal
        if (event.origin !== "https://centinelapistag.cardinalcommerce.com") {
          return;
        }

        let data = event.data;

        // Cardinal may send the message as a JSON string
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (error) {
            return;
          }
        }

        if (
          data &&
          (data.MessageType === "profile.completed" ||
            data.messageType === "profile.completed")
        ) {
          finish(
            `Device data collection completed (Status: ${
              data.Status ?? data.status
            }).`,
          );
        }
      };

      window.addEventListener("message", onMessage);

      /**
       * Create hidden iframe
       */
      const iframe = document.createElement("iframe");

      iframe.id = "cardinal_collection_iframe";
      iframe.name = "collectionIframe";
      iframe.height = "10";
      iframe.width = "10";

      iframe.style.display = "none";

      document.body.appendChild(iframe);

      /**
       * Create form
       */
      const form = document.createElement("form");

      form.id = "cardinal_collection_form";
      form.method = "POST";
      form.target = "collectionIframe";
      form.action = deviceDataCollectionUrl;

      /**
       * Add JWT
       */
      const input = document.createElement("input");

      input.id = "cardinal_collection_form_input";
      input.type = "hidden";
      input.name = "JWT";
      input.value = accessToken;

      form.appendChild(input);

      document.body.appendChild(form);

      /**
       * Submit form
       */
      let submitted = false;

      const submit = () => {
        if (submitted || done) {
          return;
        }

        submitted = true;

        form.submit();
      };

      iframe.addEventListener("load", submit);

      // Fallback in case iframe load event doesn't fire
      setTimeout(submit, 300);

      /**
       * Timeout after 10 seconds
       */
      setTimeout(() => {
        finish(
          "Device data collection timed out after 10s — proceeding anyway.",
        );
      }, 10000);
    });
  }

  showChallengeFrame(acsUrl, token) {
    const container = document.getElementById("challenge-container");
    container.innerHTML = "";

    const statusEl = document.createElement("div");
    statusEl.id = "challenge-status";
    statusEl.style.cssText = "font-size:12px;color:#666;margin-bottom:8px;";
    // statusEl.textContent = "Challenge submitted. Waiting for Cardinal ACS...";
    container.appendChild(statusEl);

    const iframe = document.createElement("iframe");
    iframe.id = "challenge_iframe";
    iframe.name = "challengeIframe";
    iframe.style.width = "100%";
    iframe.style.height = "400px";
    iframe.style.border = "1px solid #ddd";
    iframe.style.borderRadius = "8px";
    container.appendChild(iframe);

    const form = document.createElement("form");
    form.method = "POST";
    form.target = "challengeIframe";
    form.action = acsUrl;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "JWT";
    input.value = token;
    form.appendChild(input);
    container.appendChild(form);

    /* Manual TransactionId input + authorize button */
    // const actionsDiv = document.createElement("div");
    // actionsDiv.style.cssText = "margin-top:12px;display:none;";
    // actionsDiv.id = "challenge-actions";

    // container.appendChild(actionsDiv);

    this.hide("spinner-challenge-frame");

    if (!token) {
      statusEl.textContent =
        "Challenge unavailable - no JWT in the charge response.";
      return;
    }
    window.addEventListener("message", (event) => {});

    form.submit();

    /* Poll CPS /getTransactionStatus until the backend reports
       AUTHORIZATION_REQUIRED (03) — meaning the cardinalCallBack has landed —
       then authorize the payment with the stored card details. */
    this.startChallengePoll(statusEl);
  }

  private startChallengePoll(statusEl: HTMLDivElement): void {
    const transactionReference = this.paymentDetails?.referenceId;
    if (!transactionReference) {
      statusEl.textContent = "Unable to monitor challenge status.";
      return;
    }

    const payload = { transactionReference };
    const POLL_INTERVAL = 3000;
    const MAX_DURATION = 90000;

    timer(0, POLL_INTERVAL)
      .pipe(
        takeUntil(
          timer(MAX_DURATION).pipe(
            tap(() => {
              statusEl.textContent =
                "Challenge verification timed out. Please try again.";
              this.subHeader = "Challenge verification timed out";
              this.showModal = true;
            }),
          ),
        ),
        takeUntil(this.destroy$),
        switchMap(() => this.txnserv.confirmTransfer(payload, false, true)),
      )
      .subscribe(
        (response: ConfirmAccountTransfer) => {
          if (response.responseCode === ResponseCodes.success) {
            statusEl.textContent = "Payment authorized.";
            this.setTxnStatusMessage(response.responseCode);
            return;
          }

          if (response.responseCode === ResponseCodes.authorizationRequired) {
            if (this.challengeAuthorizeFired) {
              return;
            }
            this.challengeAuthorizeFired = true;
            statusEl.textContent = "Challenge complete. Authorizing payment...";
            this.challengeAuthorize();
            return;
          }

          if (response.responseCode === ResponseCodes.error) {
            statusEl.textContent = "Payment failed.";
            this.subHeader = response.responseDescription || "Payment failed";
            this.showModal = true;
            return;
          }

          statusEl.textContent = "Waiting for OTP verification...";
        },
        (err) => {},
      );
  }

  handleChallengeMessage = (event: MessageEvent) => {
    // Verify origin before trusting the payload
    if (event.origin !== "https://centinelapistag.cardinalcommerce.com") {
      return;
    }

    if (event.data?.type === "3DS_CHALLENGE_COMPLETE") {
      window.removeEventListener("message", this.handleChallengeMessage);
    }
  };

  async challengeAuthorize(): Promise<void> {
    const transactionResponse = this.transactionResponse;

    if (!transactionResponse?.paymentId) {
      this.subHeader = "Unable to authorize 3DS payment";
      this.showModal = true;
      return;
    }

    const reqToEncrypt = {
      paymentId: transactionResponse.paymentId,
      cardDetails: this.paymentRequest.cardDetails,
    };

    let encrypted;
    try {
      encrypted = await util.encryptData(reqToEncrypt);
    } catch (error) {
      this.subHeader = "Unable to authorize 3DS payment";
      this.showModal = true;
      return;
    }

    this.txnserv.authorizeCard(encrypted).subscribe(
      async (res) => {
        const decryptedRes = await util.decryptData(res.encryptedResponse);
        const response =
          typeof decryptedRes === "string"
            ? JSON.parse(decryptedRes)
            : decryptedRes;

        if (response.responseCode === ResponseCodes.success) {
          this.setTxnStatusMessage(response.responseCode);
        } else {
          this.subHeader = response.responseDescription;
          this.showModal = true;
        }
      },
      (err) => {
        this.subHeader = err?.error?.responseMessage || "Authorization failed";
        this.showModal = true;
      },
    );
  }

  private hide(elementId: string): void {
    const el = document.getElementById(elementId);
    if (el) {
      el.style.display = "none";
    }
  }

  private listenForChallengeCallback(): void {
    window.addEventListener("message", (event: MessageEvent) => {
      let data = event.data;

      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          // Not JSON
        }
      }
    });
  }
}
